<template>
    <div class="loading-style">
        <div class="loading-style__template m-b-24">
            <strong>{{ $t('loading_screen.select_template') }}</strong>
            <a-select class="m-t-12" :prefixCls="$prefixClass.select" style="width: 100%;" v-model="formStyle.template_active">
                <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                <a-select-option v-if="!formStyle.template_active" value="">{{$t('loading_screen.choose_template')}}</a-select-option>
                <a-select-option v-for="template in templates" :key="template" :value="template">{{$t('loading_screen.' + template)}}</a-select-option>
            </a-select>
        </div>
        <template v-if="formStyle.template_active">
            <div class="loading-style__component m-b-24">
                <p class="display-space-between align-items-center">
                    <strong>{{$t('loading_screen.components_text')}}</strong>
                    <a class="a-link info-color fz-14" @click="openModalReset">{{$t('loading_screen.reset_value')}}</a>
                </p>
                <draggable  tag="div" :list="listComponentSetting" class="list-group list-setting" handle=".handle" @change="changePosition">
                    <div :class="['list-setting__item', !element.isDisplay ? 'hidden' : '']"
                        @mousedown="dragMouseDown"
                        v-for="element in listComponentSetting"
                        :key="element.value"
                    >
                        <div :class="['list-setting__item__left d-flex align-items-center']" @click="editComponent(element.value)">
                            <i class="fas fa-grip-vertical icon-custom handle"></i>
                            <div>
                                <div>
                                    <span class="list-setting__item__name">{{ element.text }} </span>
                                    <!-- <a-tooltip v-if="element.tooltip" overlayClassName="choose-image-tooltip"
                                        :prefixCls="$prefixClass.tooltip"
                                        placement="right"
                                        :title="element.tooltip"
                                    >
                                        <i :class="[element.icon, 'cursor-pointer fz-14']"></i>
                                    </a-tooltip> -->
                                </div>
                                <div v-if="!element.isDisplay">
                                    <i class="fas fa-eye-slash icon-custom m-r-5"></i>
                                    <span>{{ $t('loading_screen.hidden') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="list-setting__item__icon">
                            <i :class="['m-r-8 icon-custom', element.isDisplay ? 'fas fa-eye' : 'fas fa-eye-slash']" @click="changeDisplay(element)"></i>
                            <i class="far fa-pen icon-custom" @click="editComponent(element.value)"></i>
                        </div>
                    </div>
                </draggable>
            </div>
            <div class="loading-style__background">
                <strong> {{ $t('loading_screen.background_settings') }}</strong>
                <a-radio-group class="m-t-16" v-model="templateSelected.background.type">
                    <div class="m-b-8">
                        <a-radio value="color"> {{ $t('loading_screen.solid_color') }}</a-radio>
                        <VueColorpicker v-model="templateSelected.background.color"
                            :class="[templateSelected.background.type === 'image' ? 'field-disabled' : '']"/>
                    </div>
                    <div>
                        <a-radio class="m-b-8" value="image"> {{ $t('loading_screen.custom_background') }} </a-radio>
                        <vue-upload-image :class="[templateSelected.background.type === 'color' ? 'field-disabled' : '']"
                            :maximumSize="maximumSize"
                            :maximumFile="1"
                            :multiple="false"
                            :value="images"
                            :classContainer="$prefixClass.updateImage + '-single'"
                            @change="uploadImages"
                        > </vue-upload-image>
                    </div>
                </a-radio-group>
            </div>
            <vue-modal-confirm v-model="modalResetData"
                @doAction="resetDefaultValue"
            />
        </template>
        <template v-else >
            <strong>{{$t('loading_screen.components_text')}}</strong>
            <div :class="[$prefixClass.card + '-stroke', 'loading-style__component-empty']">
                <img class="m-b-14" src="./../assets/empty.svg"/><br>
                <span>{{$t('loading_screen.select_theme_above')}}</span>
            </div>
        </template>
        
    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    import { types as typesPrefetch } from './../constant'
    import draggable from 'vuedraggable'
    import remove from 'lodash/remove'
    export default {
        name: 'Style',
        metaInfo: {
            title: 'Style Screen'
        },
        props: {
            value: {
                type: Object,
                required: true
            },
            listComponentSetting: {
                type: Array,
                required: true
            }
        },
        components: {
            draggable
        },
        data() {
            return {
                reDemo: 0,
                maximumSize: 1,
                templates: ['simple_2', 'simple_1', 'simple_3', 'simple_4'],
                dragging: true,
                classLoading: '',
                modalResetData: {
                    isVisible: false,
                    content: ''
                }
            }
        },
        computed: {
            formStyle: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },
            draggingInfo() {
                return this.dragging ? "under drag" : "";
            },
            images() {
                let images = []
                if ( this.templateSelected.background.src ) {
                    let src = typeof(this.templateSelected.background.src) === 'object' ? this.templateSelected.background.src.src : this.templateSelected.background.src
                    images.push({src: src})
                }
                return images
            },
            templateSelected() {
                return this.formStyle && this.formStyle.template_active ? this.formStyle[this.formStyle.template_active] : null
            },
        },
        watch: {
            reDemo: {
                handler() {
                    this.$emit('runDemo')
                },
                deep: true
            }
        },
        created() {
        },
        methods: {
            changeDisplay(component) {
                component.isDisplay = !component.isDisplay;
                if ( component.isDisplay ) {
                    this.templateSelected.componentsDisplay.push(component.value)
                } else {
                    let componentDisplay = this.templateSelected.componentsDisplay.filter(value => value != component.value)
                    this.templateSelected.componentsDisplay = componentDisplay
                }
                this.reDemo++
            },
            changePosition() {
                let elements = document.getElementsByClassName('draggable')
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('draggable');
                }
                for (let index in this.listComponentSetting) {
                    let componentName = this.listComponentSetting[index].value
                    this.templateSelected[componentName].positionIndex = index
                }
                this.reDemo++
            },
            dragMouseDown() {
                let element = $('div[draggable=true]')[0]
                $(element).addClass('draggable')
            },
            resetDefaultValue() {
                this.$emit('resetDefaultValue')
            },
            openModalReset() {
                this.modalResetData.content = this.$t('loading_screen.confirm.reset_data', {template_name: this.$t('loading_screen.' + this.formStyle.template_active)})
                this.modalResetData.isVisible = true
            },
            uploadImages(images){
                this.templateSelected.background.src = images.length > 0 ? images[0] : ''
            },
            editComponent(value) {
                this.$emit('editComponent', value)
            }
        }
    }
</script>
<style lang="scss">
    .loading-style {
        padding: 0 24px 24px 24px;
        .icon-custom {
            color: $text-color-secondary;
            font-size: 14px;
            cursor: pointer;
        }
        &__component {
            .list-setting {
                border: 1px solid $line-color;
                border-radius: 8px;
                &__item {
                    height: 48px;
                    padding: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &.hidden {
                        color: $text-color-secondary;
                        font-size: 14px;
                        background: $background-color;
                    }
                    &:hover {
                        background-color: $primary-light;
                        cursor: pointer;
                    }
                    &:first-child:hover {
                        border-radius: 7px 7px 0 0;
                    }
                    &:last-child:hover {
                        border-radius: 0 0 7px 7px;
                    }
                    &:not(:first-child) {
                        border-top: 1px solid $line-color;
                    }
                    &.draggable {
                        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
                    }
                    &__left {
                        height: 50px;
                        width: 85%;
                        align-items: right;
                        .fa-grip-vertical {
                            cursor: move;
                            margin-right: 16px;
                            &.handle {
                                &:hover {
                                    color: $primary-color;
                                }

                            }
                        }
                    }
                }
            }
            &-empty {
                text-align: center;
                padding: 16px 0 24px 0;
                margin-top: 12px;
            }
        }
        &__background {
            .a-radio-group {
                width: 100%;
                > div:first-child {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
        }
    }
</style>
